import { mapGetters, mapState } from 'vuex';
import formatterMixin from './formatterMixin';

const promoMixin = {
  mixins: [formatterMixin],
  computed: {
    ...mapState({
      promos: (state) => state.promo.promos,
      potentialUsers: state => state.promo.potentialUsers,
      showActionModal: (state) => state.promo.showActionModal,
      actionModalView: (state) => state.promo.actionModalView,
      activeTab: (state) => state.promo.activeTab,
      selectedPromo: (state) => state.promo.selectedPromo,
    }),
    ...mapGetters([
      'promoTableData',
      'activeCount',
      'inactiveCount',
    ]),
  },
  methods: {
    toggleActionModal(show, view) {
      if (!show) {
        this.$store.dispatch('changePromoValue', {
          field: 'showActionModal',
          value: false,
        });
      } else {
        const changes = [{
          field: 'showActionModal',
          value: show,
        }, {
          field: 'actionModalView',
          value: view,
        }];
        this.$store.dispatch('changePromoValues', changes);
      }
    },
    selectImage(payload) {
      const {
        image,
        prevType,
      } = payload;
      const formData = new FormData();
      formData.append('photo', image);
      this.$store.dispatch('changePromoValue', {
        field: prevType,
        value: formData,
      });
    },
    toggleProfileTab(tab) {
      this.$store.dispatch('changePromoValue', {
        field: 'activeTab',
        value: tab,
      });
    },
  },
};

export default promoMixin;
